import { render, staticRenderFns } from "./vizetakiplistesi.vue?vue&type=template&id=56f8d2f6&"
import script from "./vizetakiplistesi.vue?vue&type=script&lang=js&"
export * from "./vizetakiplistesi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports